import React from 'react'

import { Grid } from '../../components/Base/Base'
import { Text } from '../../components/Text/Text'
import { lightGray1, midGray } from '../../theme/colors'

interface SafetyDashboardHeaderProps {
  children: React.ReactNode
  updatedAt: Date | null
  dotNumber: string
}

export function SafetyDashboardHeader({ children, updatedAt, dotNumber }: SafetyDashboardHeaderProps) {
  return (
    <>
      <Grid columns="1fr auto" alignItems="center" xsColumns="1fr">
        {children}
        {updatedAt ? (
          <Text variant="label3" fontColor={lightGray1} align="">
            Updated on{' '}
            {updatedAt.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}
          </Text>
        ) : null}
      </Grid>

      <Text variant="label2" fontColor={midGray} mt={2}>
        US DOT# {dotNumber}
      </Text>
    </>
  )
}
